import { CONTACTS_SEARCH_TABLE_INITIAL_PAGE } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/table";
import type { ContactsSearchResultsRequestDto } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";

export const createContactsTopNSearchResultsDto = (
    dto: ContactsSearchResultsRequestDto,
    topN: number,
    isAggregatedDataUsed: boolean,
): ContactsSearchResultsRequestDto => ({
    ...dto,
    leadGenTrafficAggregationEnabled: isAggregatedDataUsed,
    page: CONTACTS_SEARCH_TABLE_INITIAL_PAGE,
    pageSize: topN,
});
